import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { CurrencyExchangeMaintenanceProvider } from "presentation/store/CurrencyExchange/CurrencyExchangeMaintenanceProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { CurrencyExchangeMasterView } from "presentation/view/section/CurrencyExchange/CurrencyExchangeMasterView";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const CurrencyExchangeMaintenanceCont = () => {
    return <ANAInfoWrapper permission={Permission.CURRENCY_EXCHANGE_MAINTENANCE}>
        <MessageBarWrapper>
            <CurrencyExchangeMaintenanceProvider>
                <GridStyles/>
                <CurrencyExchangeMasterView/>
            </CurrencyExchangeMaintenanceProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default CurrencyExchangeMaintenanceCont;